import Project from "../components/projects/Project";

import React,{useEffect} from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

import { projects } from "../helpers/projectsList";

function Projects() {
  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <main className="section">
      <div className="container">
        <h2 className="title-1">Projects</h2>
        <ul className="projects" data-aos="zoom-in" data-aos-duration="500">
          {projects.map((obj, i) => {
            /* ставить индекс в ключ компонента явлется неправильным, 
            но сейчас это нужно, так как больше уникальных идентификаторов нет 
            в будущем не забудь поменять
            все работай заебал */
            return <Project key={i} title={obj.title} img={obj.img} i={i} />;
          })}
        </ul>
      </div>
    </main>
  );
}

export default Projects;
